import React, { useState, useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';

//antd imports
import { Drawer, Form, Modal } from 'antd';

//custom component imports
import SideDrawer from '../../components/SideDrawer/SideDrawer';
import Hamburger from '../../components/Hamburger/hamburger';
import Input from '../../components/Input/CustomInput';
import Button from '../../components/Button/CustomButton';

//redux functions imports
import {
    updateEmail,
    updatePhone,
    updateUserObj,
    updateCompanyLogo,
} from '../../slice/paymentsSlice';

//helper functions imports
import {
    getErrorNotification,
    getInfoNotification,
    loginApiBase,
} from '../../utils/apiServiceHelpers';
import { storeEncryptedNumber } from '../../utils/encryption';
import { post, get } from '../../utils/apiService';
import {
    sessionStorageKeys,
    decodeJWT,
    clearUserDataFromStorage,
    localStorageKeys,
} from '../../utils';
import {
    EventProperites,
    handlEvents,
    MixPanelCategory,
    MixPanelCTA,
    MixPanelEvents,
} from '../../lib/mixPanel';
import { APIS } from '../../helpers/constants';

import backArrowSVG from '../../public/backArrow.svg';
import billzyLiteSVG from '../../public/billzyLite.svg';
import billzyLogoPNG from '../../public/billzy_logo.png';
import pciDssCertifiedSVG from '../../public/pciDssCertified.svg';
import footerPNG from '../../public/footer.png';
import textSVG from '../../public/text.svg';
import textWebSVG from '../../public/text_web.svg';

//css imports
import styles from './Layout.module.css';
import homeStyles from './home.module.css';
import { useDispatch, useSelector } from 'react-redux';

export const IsUserLoggedIn = React.createContext(false);

const defaultStateValue = {
    showLoginDrawer: false,
    phone: '',
    countsLeft: 0,
    showOtpDrawer: false,
    showLoginDesktopDrawer: false,
    phoneError: false,
    phoneErrorMessage: '',
    userLoggedIn: false,
    fetchDataCheck: false,
    otp: '',
    showOTPDesktopPopUp: false,
    afterLoginClbck: () => {},
    renderPage: false,
    otpErrorMessage: '',
    email: '',
    emailError: false,
    emailErrorMessage: '',
    showEmailDesktopDrawer: false,
    showEmailOtpDrawer: false,
    showEmailDrawer: false,
    emailOtp: '',
    emailOtpError: false,
    emailOtpErrorMsg: '',
    showEmailOTPDesktopPopUp: false,
    userEmail: '',
    userPhone: '',
    profileSettingPhoneUpdation: false,
    showAlert: false,
    currentPath: '',
    showLoginCTA: true,
    showPwaInstallDrawer: false,
    showPwaPrompt: false,
};
const Logo = ({ logo, logoSrc }) => {
    return (
        <Image
            src={logoSrc}
            alt="billzy_logo-image"
            className={
                logo === '/billzy_logo.png' || logo === '/billzyLite.svg'
                    ? 'billzy_logo'
                    : 'company_logo'
            }
            width={91}
            height={51}
        />
    );
};
const goToPrevScreen = () => {
    window.history.back();
};
const RenderLogo = ({
    isCreateAccount,
    isOtpPage,
    paymentSuccessInfo,
    isHome,
    isEnach,
    isPaymentProgress,
    frmFailure,
    paymentStatus,
    logo,
    logoSrc,
    frmDeeplink,
    bckUrl,
    frmBck,
    showBillzyLogo,
}) => {
    if (isCreateAccount || isOtpPage) {
        return (
            <Image
                src={backArrowSVG}
                className="backarrow_logo"
                onClick={goToPrevScreen}
                alt="backArrow-image"
            />
        );
    }
    return (
        <>
            {isHome ||
            paymentSuccessInfo ||
            isEnach ||
            (isPaymentProgress && frmFailure) ||
            paymentStatus ||
            showBillzyLogo ? (
                <Logo logo={logo} logoSrc={logoSrc} />
            ) : (
                <>
                    {(frmDeeplink && !bckUrl) ||
                    (isPaymentProgress && !frmFailure) ? (
                        <Logo logo={logo} logoSrc={logoSrc} />
                    ) : (
                        <>
                            {bckUrl || frmBck ? (
                                <div
                                    style={{
                                        display: 'grid',
                                        gap: '15px',
                                    }}
                                >
                                    <Image
                                        src={backArrowSVG}
                                        className="backarrow_logo"
                                        onClick={goToPrevScreen}
                                        alt="backArrow-image"
                                    />
                                    <Logo logo={logo} logoSrc={logoSrc} />
                                </div>
                            ) : null}
                        </>
                    )}
                </>
            )}
        </>
    );
};
const formateFirstName = (fname = '') => {
    if (fname?.length > 12) return `${fname?.slice(0, 12)}...`;
    else return fname;
};
const RenderRightSideCTA = ({
    isCreateAccount,
    isOtpPage,
    userLoggedIn,
    state,
    onClickLoginBtn,
    userObj,
    displaySideDrawer,
}) => {
    if (state.showLoginCTA && !isCreateAccount && !isOtpPage) {
        return (
            <div className={`${homeStyles.right_items}`}>
                <div
                    className={`${homeStyles.loginBtn} `}
                    onClick={() => {
                        if (!userLoggedIn) {
                            onClickLoginBtn();
                            handlEvents({
                                events: MixPanelEvents['Billzy_Login'],
                                module: EventProperites['User Login'],
                                category: MixPanelCategory.Authentication,
                                cta: MixPanelCTA.click,
                            });
                        }
                    }}
                >
                    {!userLoggedIn
                        ? 'Login'
                        : formateFirstName(userObj['fname'])}
                </div>

                <Hamburger
                    isUserLoggedIn={userLoggedIn}
                    displaySideDrawer={displaySideDrawer}
                />
            </div>
        );
    }
    return null;
};

const Layout = (props) => {
    const [state, setState] = useState(defaultStateValue);
    const [bipEvent, setBipEvent] = useState(null);

    const router = useRouter();
    const dispatch = useDispatch();
    const { pathname } = router;
    const { isMobile, isStandaoloneApp = false, children } = props;
    const { showBillzyLogo, userObj, companyLogo } = useSelector(
        (state) => state.payments
    );

    const displaySideDrawer = () => {
        setState((prev) => ({
            ...prev,
            showSideDrawer: true,
        }));
    };

    const closeSideDrawer = () =>
        setState((prev) => ({
            ...prev,
            showSideDrawer: false,
        }));

    const getLogo = (isStandalone) => {
        let logo;
        let logoSrc = billzyLogoPNG;
        if (companyLogo && companyLogo == '/billzy_logo.png') {
            if (isStandaoloneApp || isStandalone) {
                logo = '/billzyLite.svg';
                logoSrc = billzyLiteSVG;
            } else logo = companyLogo;
        } else {
            logo = companyLogo;
            logoSrc = companyLogo;
        }
        return { logo, logoSrc };
    };

    const renderHeader = () => {
        const { userLoggedIn } = state;
        const {
            bckUrl,
            frmBck,
            hideHeader = false,
            frmFailure,
            frmDeeplink,
            isStandalone = false,
        } = router.query;

        const isHome = pathname && pathname.indexOf('home') > -1;
        const isPaymentProgress =
            pathname && pathname.indexOf('payment-progress') > -1;
        const isDeeplinkLanding =
            pathname &&
            pathname.indexOf('deeplink-landing') > -1 &&
            !showBillzyLogo;
        const isCreateAccount =
            pathname && pathname.indexOf('create-account') > -1;
        const isOtpPage = pathname && pathname.indexOf('otp') > -1;
        const paymentSuccessInfo =
            pathname && pathname.indexOf('paymentSuccessInfo') > -1;
        const isEnach = pathname && pathname.indexOf('enach') > -1;
        const paymentStatus =
            pathname && pathname.indexOf('payment-status') > -1;
        if (hideHeader || isDeeplinkLanding) return null;
        const { logo, logoSrc } = getLogo(isStandalone);
        return (
            <div className={`${homeStyles.home_page_header}`}>
                <div className="logo">
                    <RenderLogo
                        isCreateAccount={isCreateAccount}
                        isOtpPage={isOtpPage}
                        paymentSuccessInfo={paymentSuccessInfo}
                        isHome={isHome}
                        isEnach={isEnach}
                        isPaymentProgress={isPaymentProgress}
                        frmFailure={frmFailure}
                        paymentStatus={paymentStatus}
                        logo={logo}
                        logoSrc={logoSrc}
                        frmDeeplink={frmDeeplink}
                        bckUrl={bckUrl}
                        frmBck={frmBck}
                        showBillzyLogo={showBillzyLogo}
                    />
                </div>
                <RenderRightSideCTA
                    isCreateAccount={isCreateAccount}
                    isOtpPage={isOtpPage}
                    userLoggedIn={userLoggedIn}
                    state={state}
                    onClickLoginBtn={onClickLoginBtn}
                    userObj={userObj}
                    displaySideDrawer={displaySideDrawer}
                />
            </div>
        );
    };

    const onCloseLoginDrawer = () => {
        setState((prev) => ({
            ...prev,
            showLoginDrawer: false,
            showLoginDesktopDrawer: false,
        }));
        sessionStorage.setItem(sessionStorageKeys.LOGIN_POPUP, 'false');
    };

    const onClickLoginBtn = (isSideDrawer = false) => {
        isMobile
            ? setState((prev) => ({
                  ...prev,
                  showLoginDrawer: true,
                  showSideDrawer: false,
              }))
            : setState((prev) => ({
                  ...prev,
                  showLoginDesktopDrawer: true,
                  showSideDrawer: false,
              }));
    };

    const onClickEmailBtn = () => {
        isMobile
            ? setState((prev) => ({
                  ...prev,
                  showEmailDrawer: true,
                  showSideDrawer: false,
              }))
            : setState((prev) => ({
                  ...prev,
                  showEmailDesktopDrawer: true,
                  showSideDrawer: false,
              }));
    };

    const onChangePhone = (event) => {
        if (event.target.value?.length > 10) {
            setState((prev) => ({
                ...prev,
                phoneError: true,
                phoneErrorMessage: 'Mobile number cannot be greater than 10',
            }));
            return false;
        }
        setState((prev) => ({
            ...prev,
            phone: event.target.value,
        }));
    };

    const onChangeEmail = (event) => {
        setState((prev) => ({
            ...prev,
            email: event.target.value,
        }));
    };

    const onChangeOTP = (event) => {
        if (event.target.value?.length > 6) {
            setState((prev) => ({
                ...prev,
                optError: true,
                otpErrorMessage: "OTP shouldn't exceed 6 digits",
            }));
            return false;
        }
        setState((prev) => ({
            ...prev,
            otp: event.target.value,
        }));
    };

    const redirectToCreateAccount = () => {
        const pathname = window.location.pathname;
        sessionStorage.setItem(
            sessionStorageKeys.CREATE_ACC_HIT_URL,
            window.location.href
        );
        window.location.href = `/v2/create-account?bckUrl=${pathname}`;
    };

    const onCloseOtpDrawer = () =>
        setState((prev) => ({
            ...prev,
            showOtpDrawer: false,
        }));

    const validateInput = (mobile) => {
        const phone = state.phone || mobile;
        setState((prev) => ({
            ...prev,
            phoneError: !phone || phone?.length != 10,
        }));
        return phone && phone.length === 10;
    };

    const generatePayload = (mobile) => {
        const phone = state.phone || mobile;
        return { identity_value: phone };
    };

    const onClickProceedLogin = async (mobile) => {
        setState((prev) => ({
            ...prev,
            phoneErrorMessage: '',
            otpErrorMessage: '',
            optError: false,
            phoneError: false,
        }));

        sessionStorage.setItem(sessionStorageKeys.LOGIN_POPUP, 'false');
        if (validateInput(mobile)) {
            try {
                if (mobile)
                    setState((prev) => ({
                        ...prev,
                        phone: mobile,
                    }));
                const payload = generatePayload(mobile);
                setState((prev) => ({
                    ...prev,
                    btnLoadingState: true,
                }));
                const response = await post({
                    endPoint: APIS.LOGIN_API,
                    payload: payload,
                    responseType: 'json',
                    useLoginApiBase: true,
                });
                setState((prev) => ({
                    ...prev,
                    showOtpDrawer: isMobile ? true : false,
                    showOTPDesktopPopUp: !isMobile,
                    countsLeft: response?.otp_retries_left || 0,
                }));
                setState((prev) => ({
                    ...prev,
                    showLoginDesktopDrawer: false,
                    showLoginDrawer: false,
                }));
            } catch (error) {
                getErrorNotification(error);
            } finally {
                setState((prev) => ({
                    ...prev,
                    btnLoadingState: false,
                }));
            }
        }
    };
    const closeOtpPopup = () => {
        setState((prev) => ({
            ...prev,
            showOTPDesktopPopUp: false,
        }));
    };

    const generateOTPPayload = () => {
        const { phone, otp } = state;
        storeEncryptedNumber(localStorageKeys.USER_PHONE, phone);
        return { identity_value: phone, otp: otp };
    };

    const validateOTP = () => {
        const { otp } = state;
        setState((prev) => ({
            ...prev,
            optError: !otp,
        }));

        if (!otp || otp.length !== 6) {
            setState((prev) => ({
                ...prev,
                optError: true,
                otpErrorMessage: 'OTP length should be 6',
            }));
            return false;
        }
        return true;
    };
    const clearUserData = () => {
        setState((prev) => ({
            ...prev,
            userLoggedIn: false,
            otp: '',
            showSideDrawer: false,
        }));
        dispatch(updateUserObj({}));
        dispatch(updateEmail(''));
        dispatch(updatePhone(''));
        clearUserDataFromStorage();
    };

    const onClickProceedOtp = async () => {
        const { afterLoginClbck } = state;
        setState((prev) => ({
            ...prev,
            otpErrorMessage: '',
            optError: false,
        }));
        let obj = {};
        let userLoggedIn = false;
        let fetchingStatus = false;
        if (validateOTP()) {
            try {
                const payload = generateOTPPayload();
                handlEvents({
                    events: MixPanelEvents.Billzy_Login_OTP_Proceed,
                    module: EventProperites['User Login'],
                    cta: MixPanelCTA.click,
                    para1: 'Proceed',
                    mobileNumber: state?.phone,
                    dataSource: payload,
                });
                setState((prev) => ({
                    ...prev,
                    btnLoadingState: true,
                }));
                const response = await post({
                    endPoint: APIS.LOGIN_API,
                    payload: payload,
                    responseType: 'json',
                    useLoginApiBase: true,
                });
                const accessToken = response?.access_token;
                localStorage.setItem(
                    localStorageKeys.ACCESS_TOKEN,
                    accessToken
                );
                const userObj = decodeJWT(accessToken);
                sessionStorage.setItem(
                    sessionStorageKeys.LOGIN_FROM_DEEP_LINK,
                    'false'
                );
                obj = userObj;
                userLoggedIn = true;
                fetchingStatus = true;
                afterLoginClbck && afterLoginClbck();
                setState((prev) => ({
                    ...prev,
                    showAlert: true,
                    fetchDataCheck: fetchingStatus,
                }));
                if (
                    sessionStorage.getItem(
                        sessionStorageKeys.REDIRECTION_FROM_FAQ
                    ) &&
                    JSON.stringify(
                        sessionStorage.getItem(
                            sessionStorageKeys.REDIRECTION_FROM_FAQ
                        )
                    )
                ) {
                    window.location.href = sessionStorage.getItem(
                        sessionStorageKeys.REDIRECTION_FROM_FAQ
                    );
                }
                setState((prev) => ({
                    ...prev,
                    showOtpDrawer: false,
                    showOTPDesktopPopUp: false,
                    userLoggedIn,
                }));
                getProfileDetails();
                dispatch(updateUserObj(obj));
            } catch (error) {
                getErrorNotification(error);
            } finally {
                setState((prev) => ({
                    ...prev,
                    btnLoadingState: false,
                }));
            }
        }
    };

    const onCloseEmailDrawer = () => {
        setState((prev) => ({
            ...prev,
            showEmailDrawer: false,
            showEmailDesktopDrawer: false,
        }));
        sessionStorage.setItem(sessionStorageKeys.EMAIL_POPUP, false);
    };

    const generateOTPContainer = () => {
        const { otp, optError, btnLoadingState, phone, otpErrorMessage } =
            state;

        return (
            <div className={`${homeStyles.login_drawer}`}>
                <div className={`${homeStyles.drawer_title}`}>Login</div>
                <br />
                <div className={`${homeStyles.drawer_title_meta}`}>
                    Enter the 6-digit OTP sent on {phone}
                </div>
                <br />
                <Form.Item
                    validateStatus={optError ? 'error' : null}
                    help={
                        optError
                            ? otpErrorMessage || 'Please Enter a valid OTP'
                            : ''
                    }
                    rules={[
                        { required: true, message: 'Please Enter a valid OTP' },
                    ]}
                    style={{ width: '100%' }}
                >
                    <Input
                        placeholder="Enter your 6 digit OTP"
                        change={onChangeOTP}
                        type="number"
                        value={otp}
                        inputType="login"
                    />
                </Form.Item>

                <div className={styles.createAccountActionOtp}>
                    {`Attempts Left: ${state.countsLeft}`}
                    <span
                        className={` ${
                            state.countsLeft === 0
                                ? styles?.disabledResendButton
                                : styles?.inLineAction
                        }`}
                        onClick={() => {
                            onClickProceedLogin('');
                            handlEvents({
                                events: MixPanelEvents[
                                    'Billzy_Login_Resend_OTP'
                                ],
                                module: EventProperites['User Login'],
                                category: MixPanelCategory.Authentication,
                                cta: MixPanelCTA.click,
                            });
                        }}
                        style={{ textDecoration: 'underline' }}
                    >
                        Resend OTP
                    </span>
                </div>
                <br />
                <Button
                    className={styles.cgbtn}
                    click={onClickProceedOtp}
                    loading={btnLoadingState}
                    text="Proceed"
                />
            </div>
        );
    };

    const renderOtpDrawer = () => {
        const { showOtpDrawer } = state;
        return (
            <Drawer
                title=""
                placement="bottom"
                onClose={onCloseOtpDrawer}
                open={showOtpDrawer}
                bodyStyle={{
                    padding: '20px',
                    paddingTop: '56px',
                }}
                height="360px"
            >
                {generateOTPContainer()}
            </Drawer>
        );
    };

    const onCloseEmailOtpDrawer = () => {
        setState((prev) => ({
            ...prev,
            showEmailOtpDrawer: false,
        }));
    };

    const renderDesktopEmailOtpPopup = () => {
        const { showEmailOTPDesktopPopUp } = state;
        return (
            <Modal
                title=""
                open={showEmailOTPDesktopPopUp}
                footer={null}
                wrapClassName="modal-class"
                onCancel={() => {
                    setState((prev) => ({
                        ...prev,
                        showEmailOTPDesktopPopUp: false,
                    }));
                }}
                width={542}
            >
                {generateEmailOTPContainer()}
            </Modal>
        );
    };

    const renderEmailOtpDrawer = () => {
        const { showEmailOtpDrawer } = state;
        return (
            <Drawer
                title=""
                placement="bottom"
                onClose={onCloseEmailOtpDrawer}
                open={showEmailOtpDrawer}
                bodyStyle={{
                    padding: '20px',
                    paddingTop: '56px',
                }}
                height="360px"
            >
                {generateEmailOTPContainer()}
            </Drawer>
        );
    };
    const onClickProceedInstall = () => {
        if (bipEvent) {
            bipEvent.prompt();
        } else {
            setState((prev) => ({
                ...prev,
                showPwaPrompt: true,
            }));
        }
        onClosePwaInstallDrawer();
    };

    const generateLoginContainer = () => {
        const { phone, phoneError, btnLoadingState, phoneErrorMessage } = state;
        return (
            <div className={`${homeStyles.login_drawer}`}>
                <div className={`${homeStyles.drawer_title}`}>Login</div>
                <br></br>
                <div className={`${homeStyles.drawer_title_meta}`}>
                    Log-in and track your past payments and disputes!
                </div>
                <br></br>
                <Form.Item
                    validateStatus={phoneError ? 'error' : null}
                    help={
                        phoneError
                            ? phoneErrorMessage ||
                              'Please Enter a valid mobile number'
                            : ''
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Please input your username!',
                        },
                    ]}
                    style={{ width: '100%' }}
                >
                    <Input
                        placeholder="Enter Mobile Number"
                        prefix="+91"
                        change={onChangePhone}
                        type="number"
                        value={phone}
                        inputType="login"
                    />
                </Form.Item>

                <div className={styles.createAccountAction}>
                    Don't have an account ?
                    <span
                        className={styles.inLineAction}
                        onClick={() => {
                            redirectToCreateAccount();
                            handlEvents({
                                events: MixPanelEvents[
                                    'Billzy_sidebar_Login_Create_an_account'
                                ],
                                module: EventProperites[
                                    'Billzy -Create an Account'
                                ],
                                category: MixPanelCategory.Authentication,
                                cta: MixPanelCTA.click,
                            });
                        }}
                    >
                        Create an account
                    </span>
                </div>

                <Button
                    text="Proceed"
                    className={styles.cgbtn}
                    click={() => {
                        onClickProceedLogin('');
                        handlEvents({
                            events: MixPanelEvents.Billzy_Login_Proceed,
                            module: EventProperites['User Login'],
                            cta: MixPanelCTA.click,
                            dataSource: generatePayload(''),
                        });
                    }}
                    loading={btnLoadingState}
                />
            </div>
        );
    };

    const generatePwaInstallContainer = () => {
        return (
            <div className={`${homeStyles.login_drawer}`}>
                <div className={`${homeStyles.drawer_title}`}>
                    Install Billzy Lite
                </div>

                {/* <div className={`${homeStyles.drawer_title_meta}`}>
                    Log-in and track your past payments and disputes!
                </div> */}
                <br></br>

                <div className="pwa-meta-tag">
                    Enjoy the experience of app without downloading it. Now
                    access your payment history etc in offline mode as well
                </div>
                <Image
                    src={billzyLiteSVG}
                    className="pwa-drawer-icon"
                    alt="billzyLite"
                ></Image>

                <Button
                    className={styles.cgbtn}
                    click={onClickProceedInstall}
                    text="Proceed"
                />
            </div>
        );
    };
    const onClosePwaInstallDrawer = () => {
        setState((prev) => ({
            ...prev,
            showPwaInstallDrawer: false,
        }));
    };

    const renderPwaInstallDrawer = () => {
        const { showPwaInstallDrawer } = state;
        return (
            <Drawer
                title=""
                placement="bottom"
                onClose={onClosePwaInstallDrawer}
                open={showPwaInstallDrawer}
                bodyStyle={{
                    padding: '20px',
                    paddingTop: '56px',
                }}
                height="356px"
                width="400px"
                className="pwa-install-drawer"
            >
                {generatePwaInstallContainer()}
            </Drawer>
        );
    };

    const renderEmailDrawer = () => {
        const { showEmailDrawer } = state;
        return (
            <Drawer
                title=""
                placement="bottom"
                onClose={onCloseEmailDrawer}
                open={showEmailDrawer}
                bodyStyle={{
                    padding: '20px',
                    paddingTop: '56px',
                }}
                height="300px"
            >
                {generateEmailContainer()}
            </Drawer>
        );
    };

    const renderLoginDrawer = () => {
        const { showLoginDrawer } = state;
        return (
            <Drawer
                title=""
                placement="bottom"
                onClose={onCloseLoginDrawer}
                open={showLoginDrawer}
                bodyStyle={{
                    padding: '20px',
                    paddingTop: '56px',
                }}
                height="360px"
            >
                {generateLoginContainer()}
            </Drawer>
        );
    };

    const renderDesktopEmailPopup = () => {
        const { showEmailDesktopDrawer } = state;
        return (
            <Modal
                title=""
                open={showEmailDesktopDrawer}
                footer={null}
                wrapClassName="modal-class"
                onCancel={onCloseEmailDrawer}
                width={542}
            >
                {generateEmailContainer()}
            </Modal>
        );
    };

    const validateEmail = () => {
        let emailRegExp = /^[A-Za-z0-9\.\+_-]+@[A-Za-z0-9\._-]+\.[a-zA-Z]*$/;
        if (!emailRegExp.test(state.email)) {
            setState((prev) => ({
                ...prev,
                emailError: true,
                emailErrorMessage: 'Please enter a valid email address',
            }));
            return false;
        }
        return true;
    };

    const onClickProceedEmail = async (otp = null) => {
        setState((prev) => ({
            ...prev,
            showAlert: false,
        }));
        if (otp === true && !state.emailOtp.length) {
            setState((prev) => ({
                ...prev,
                emailOtpError: true,
                emailOtpErrorMsg: 'OTP is mandatory',
            }));
            return;
        } else if (otp === true && state.emailOtp.length !== 6) {
            setState((prev) => ({
                ...prev,
                emailOtpError: true,
                emailOtpErrorMsg: 'OTP length should be 6',
            }));
            return;
        }
        setState((prev) => ({
            ...prev,
            emailErrorMessage: '',
            emailError: false,
            emailOtpError: false,
            emailOtpErrorMsg: '',
        }));
        sessionStorage.setItem(sessionStorageKeys.EMAIL_POPUP, false);
        let data = {
            identity_type: 'email',
            identity_value: state.email,
        };
        if (otp === true) {
            data = {
                ...data,
                otp: state.emailOtp,
            };
        }

        if (validateEmail()) {
            try {
                const payload = data;
                setState((prev) => ({
                    ...prev,
                    btnLoadingState: true,
                }));
                const response = await post({
                    endPoint: APIS.ADD_USER_DETAILS_API,
                    payload: payload,
                    responseType: 'json',
                    sendAuthHeader: true,
                    useLoginApiBase: true,
                });
                if (otp === true) {
                    setState((prev) => ({
                        ...prev,
                        showEmailOtpDrawer: false,
                        showEmailOTPDesktopPopUp: false,
                    }));
                    dispatch(updateEmail(state.email));
                } else {
                    setState((prev) => ({
                        ...prev,
                        showEmailOtpDrawer: isMobile ? true : false,
                        showEmailOTPDesktopPopUp: !isMobile,
                        countsLeft: response?.otp_retries_left || 0,
                    }));
                }
                setState((prev) => ({
                    ...prev,
                    showEmailDesktopDrawer: false,
                    showEmailDrawer: false,
                }));
            } catch (error) {
                getErrorNotification(error);
            } finally {
                setState((prev) => ({
                    ...prev,
                    btnLoadingState: false,
                }));
            }
        }
    };

    const generateEmailContainer = () => {
        const { email, emailError, btnLoadingState, emailErrorMessage } = state;
        return (
            <div className={`${homeStyles.login_drawer}`}>
                <div className={`${homeStyles.drawer_title_meta}`}>
                    Enter the new email address
                </div>
                <br />
                <Form.Item
                    validateStatus={emailError ? 'error' : null}
                    help={
                        emailError
                            ? emailErrorMessage ||
                              'Please Enter a valid email address'
                            : ''
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Please input your email address!',
                        },
                    ]}
                    style={{ width: '100%' }}
                >
                    <Input
                        placeholder="Enter your email address"
                        change={onChangeEmail}
                        type="text"
                        value={email}
                        inputType="login"
                    />
                </Form.Item>
                <br />
                <Button
                    className={styles.cgbtn}
                    click={onClickProceedEmail}
                    loading={btnLoadingState}
                    text="Proceed"
                />
            </div>
        );
    };

    const handleOtpChange = (e) => {
        if (e.target.value.length > 6) {
            setState((prev) => ({
                ...prev,
                emailOtpError: true,
                emailOtpErrorMsg: 'OTP cannot be greater than 6 digits',
            }));
            return;
        }
        setState((prev) => ({
            ...prev,
            emailOtp: e.target.value,
        }));
    };

    const generateEmailOTPContainer = () => {
        const {
            emailOtp,
            emailOtpError,
            btnLoadingState,
            email,
            emailOtpErrorMsg,
        } = state;

        return (
            <div className={`${homeStyles.login_drawer}`}>
                <div className={`${homeStyles.drawer_title_meta}`}>
                    {`Please verify the OTP sent to you on ${email} to add the email successfully`}
                </div>
                <br />
                <Form.Item
                    validateStatus={emailOtpError ? 'error' : null}
                    help={
                        emailOtpError
                            ? emailOtpErrorMsg || 'Please enter a valid OTP'
                            : ''
                    }
                    rules={[
                        { required: true, message: 'Please enter a valid OTP' },
                    ]}
                    style={{ width: '100%' }}
                >
                    <Input
                        placeholder="Enter your 6 digit OTP"
                        change={handleOtpChange}
                        type="number"
                        value={emailOtp}
                        inputType="login"
                    />
                </Form.Item>
                <div className={styles.createAccountActionOtp}>
                    {`Attempts Left: ${state.countsLeft}`}
                    <span
                        className={` ${
                            state.countsLeft === 0
                                ? styles?.disabledResendButton
                                : styles?.inLineAction
                        }`}
                        onClick={onClickProceedEmail}
                        style={{ textDecoration: 'underline' }}
                    >
                        Resend OTP
                    </span>
                </div>
                <br />
                <Button
                    text="Proceed"
                    className={styles.cgbtn}
                    click={() => onClickProceedEmail(true)}
                    loading={btnLoadingState}
                />
            </div>
        );
    };

    const renderDesktopLoginPopup = () => {
        const { showLoginDesktopDrawer } = state;
        return (
            <Modal
                title=""
                open={showLoginDesktopDrawer}
                footer={null}
                wrapClassName="modal-class"
                onCancel={onCloseLoginDrawer}
                width={542}
            >
                {generateLoginContainer()}
            </Modal>
        );
    };
    const renderDesktopOTPPopup = () => {
        const { showOTPDesktopPopUp } = state;
        return (
            <Modal
                title=""
                open={showOTPDesktopPopUp}
                footer={null}
                wrapClassName="modal-class"
                onCancel={closeOtpPopup}
                width={542}
            >
                {generateOTPContainer()}
            </Modal>
        );
    };

    async function getProfileDetails() {
        try {
            const response = await get({
                endPoint: `${loginApiBase}${APIS.USER_PROFILE}`,
                sendAuthHeader: true,
            });
            let { email, mobile_number, first_name, last_name } = response;
            setState((prev) => ({
                ...prev,
                userEmail: email,
                userPhone: mobile_number,
            }));
            if (state.showAlert) {
                if (!email || !email.length) {
                    setTimeout(() => {
                        getInfoNotification(
                            <div>
                                <div className="custom-message">
                                    What's new?
                                </div>
                                <span>
                                    Add email address to stay on track with
                                    Payment alerts and reminder
                                </span>
                            </div>
                        );
                    }, 5000);
                    setState((prev) => ({
                        ...prev,
                        showAlert: false,
                    }));
                    localStorage.removeItem(localStorageKeys.INFO_ALERT);
                }
            }
            dispatch(updateEmail(email));
            dispatch(updatePhone(mobile_number));
            dispatch(
                updateUserObj({
                    fname: first_name,
                    lname: last_name,
                })
            );
            let userDetails = {};
            userDetails['fname'] = first_name;
            userDetails['lname'] = last_name;
            localStorage.setItem(
                localStorageKeys.USER_DETAILS,
                JSON.stringify(userDetails)
            );
            storeEncryptedNumber(localStorageKeys.USER_PHONE, mobile_number);
            localStorage.setItem(
                sessionStorageKeys.LOGIN_FROM_DEEP_LINK,
                false
            );
        } catch (error) {
            getErrorNotification(error);
        } finally {
            setState((prev) => ({
                ...prev,
                isLoading: false,
            }));
        }
    }
    useEffect(() => {
        if (
            sessionStorage.getItem(sessionStorageKeys.SHOW_LOGIN_CTA) ===
            'false'
        )
            setState((prev) => ({
                ...prev,
                showLoginCTA: false,
            }));
        else
            setState((prev) => ({
                ...prev,
                showLoginCTA: true,
            }));

        if (sessionStorage.getItem(sessionStorageKeys.COMPANY_LOGO)?.length) {
            dispatch(
                updateCompanyLogo(
                    sessionStorage.getItem(sessionStorageKeys.COMPANY_LOGO)
                )
            );
        }
        const accessToken = localStorage.getItem(localStorageKeys.ACCESS_TOKEN);
        if (
            accessToken &&
            Object?.keys(
                JSON.parse(
                    localStorage.getItem(localStorageKeys.USER_DETAILS) || '{}'
                )
            )?.length
        ) {
            setState((prev) => ({
                ...prev,
                userLoggedIn: true,
            }));
            dispatch(
                updateUserObj(
                    JSON.parse(
                        localStorage.getItem(localStorageKeys.USER_DETAILS)
                    )
                )
            );
        } else if (accessToken) {
            const userObj = decodeJWT(accessToken);
            setState((prev) => ({
                ...prev,
                userLoggedIn: true,
            }));
            dispatch(updateUserObj(userObj));
        }

        setState((prev) => ({ ...prev, renderPage: true }));
        if (state.userLoggedIn === true) {
            getProfileDetails();
        }
        if (localStorage.getItem(localStorageKeys.INFO_ALERT) === 'true') {
            setState((prev) => ({ ...prev, showAlert: true }));
        }

        setTimeout(() => {
            const pwaDrawerInStorage = sessionStorage.getItem(
                sessionStorageKeys.PWA_INSTALL_DRAWER
            );
            if (
                !window.matchMedia('(display-mode: standalone)').matches &&
                window.location.pathname.includes('home') &&
                !pwaDrawerInStorage
            ) {
                setState((prev) => ({ ...prev, showPwaInstallDrawer: true }));
                sessionStorage.setItem(
                    sessionStorageKeys.PWA_INSTALL_DRAWER,
                    'true'
                );
            }
        }, 3000);

        window.addEventListener('beforeinstallprompt', (event) => {
            event.preventDefault();
            setBipEvent(event);
        });
    }, []);

    useEffect(() => {
        if (state.showEmailDesktopDrawer || state.showEmailDrawer) {
            setState((prev) => ({ ...prev, email: '' }));
        }
    }, [state.showEmailDesktopDrawer, state.showEmailDrawer]);

    useEffect(() => {
        if (state.showEmailOTPDesktopPopUp || state.showEmailOtpDrawer) {
            setState((prev) => ({ ...prev, emailOtp: '' }));
        }
    }, [state.showEmailOTPDesktopPopUp, state.showEmailOtpDrawer]);

    useEffect(() => {
        if (state.userLoggedIn) {
            getProfileDetails();
        }
    }, [state.userLoggedIn]);

    const openLoginModalAndDrawer = (display, afterLoginClbck) => {
        const isMobile = JSON.parse(
            sessionStorage.getItem(sessionStorageKeys.IS_MOBILE)
        );
        if (display) {
            setState((prev) => ({
                ...prev,
                showLoginDesktopDrawer: !isMobile ? true : false,
                showLoginDrawer: isMobile ? true : false,
                afterLoginClbck: afterLoginClbck,
            }));
        } else {
            setState((prev) => ({
                ...prev,
                showLoginDesktopDrawer: false,
                showLoginDrawer: false,
            }));
        }
    };

    const toggleLoginCTA = (val) => {
        setState((prev) => ({ ...prev, showLoginCTA: val }));
    };

    const toggleLogin = () => {
        setState((prev) => ({ ...prev, userLoggedIn: true }));
    };
    const renderFooter = () => {
        return (
            <div className="footer">
                {router?.pathname == '/home' ? (
                    <Image
                        src={pciDssCertifiedSVG}
                        alt="PCI-DSS certified"
                        style={{ width: '93px', height: '24px' }}
                    />
                ) : (
                    <>
                        {router?.pathname === '/v2/paymentMethods' ? (
                            <Image
                                src={pciDssCertifiedSVG}
                                alt="PCI-DSS certified"
                                style={{ width: '100px', height: '44px' }}
                            />
                        ) : (
                            <>
                                <Image
                                    src={footerPNG}
                                    alt="Powered by billzy"
                                    style={{
                                        width: isMobile ? '130px' : '150px',
                                        height: '25px',
                                    }}
                                />
                                <Image
                                    src={isMobile ? textSVG : textWebSVG}
                                    alt="text"
                                    style={{
                                        marginLeft: !isMobile ? '10px' : '0px',
                                        width: !isMobile ? '230px' : '168px',
                                        height: !isMobile ? '40px' : '32px',
                                    }}
                                />
                            </>
                        )}
                    </>
                )}
            </div>
        );
    };
    const isDeeplinkLanding =
        pathname &&
        pathname.indexOf('deeplink-landing') > -1 &&
        !showBillzyLogo;
    const isCreateAccount = pathname && pathname.indexOf('create-account') > -1;
    const { userLoggedIn, showSideDrawer, renderPage, fetchDataCheck } = state;
    const contextValue = useMemo(
        () => ({
            userLoggedIn,
            fetchData: fetchDataCheck,
            isMobile,
            toggleLoginModalAndDrawer: openLoginModalAndDrawer,
            onClickEmailAdd: onClickEmailBtn,
            toggleLoginCTA,
            toggleLogin,
            onClickProceedLogin,
            onClickProceedOtp,
            clearUserData,
        }),
        [
            userLoggedIn,
            fetchDataCheck,
            isMobile,
            openLoginModalAndDrawer,
            onClickEmailBtn,
            toggleLoginCTA,
            toggleLogin,
            onClickProceedLogin,
            onClickProceedOtp,
            clearUserData,
        ]
    );
    return (
        <div className={`${styles.pageContainer}`}>
            <div
                className={`${styles.pageLayout} ${
                    isDeeplinkLanding ? styles.deepLinkLanding : ''
                } ${isCreateAccount ? styles.fixedHeight : ''} `}
            >
                {renderHeader()}
                <div className="footerWrapper">
                    {renderPage ? (
                        <IsUserLoggedIn.Provider value={contextValue}>
                            {children}
                        </IsUserLoggedIn.Provider>
                    ) : null}
                </div>
                {isMobile ? renderLoginDrawer() : renderDesktopLoginPopup()}
                {isMobile ? renderOtpDrawer() : renderDesktopOTPPopup()}
                {isMobile ? renderEmailDrawer() : renderDesktopEmailPopup()}

                {isMobile
                    ? renderEmailOtpDrawer()
                    : renderDesktopEmailOtpPopup()}
                {isMobile ? renderPwaInstallDrawer() : null}

                <SideDrawer
                    onClickLoginBtn={onClickLoginBtn}
                    onClickEmailAdd={onClickEmailBtn}
                    isMobile={isMobile}
                    userLoggedIn={userLoggedIn}
                    clearUserData={clearUserData}
                    showSideDrawer={showSideDrawer}
                    closeSideDrawer={closeSideDrawer}
                />
                {renderFooter()}
            </div>
            <Modal
                title=""
                open={state.showPwaPrompt}
                footer={[
                    <Button
                        text="OK"
                        key="ok"
                        click={() =>
                            setState((prev) => ({
                                ...prev,
                                showPwaPrompt: false,
                            }))
                        }
                    ></Button>,
                ]}
                wrapClassName="modal-class"
                closable={false}
            >
                To enjoy the benefits of app like experience, please add the
                billzy bookmark to home or install via your browser menu.
            </Modal>
        </div>
    );
};

export default Layout;
